import React from 'react'
import { X } from 'lucide-react'
import type { PendingApplicationsProps } from '@/features/enrollment'

export default function PendingApplications({
  pendingApplications,
  showPendingApplications,
  setShowPendingApplications,
  onRefreshPendingApplications
}: PendingApplicationsProps) {
  
  if (!showPendingApplications) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Applications</h3>
          <div className="flex items-center gap-2">
            <button 
              className="text-primary-600 hover:text-primary-800 text-sm"
              onClick={() => onRefreshPendingApplications()}
            >
              Refresh
            </button>
            <button 
              className="text-accent-500 hover:text-accent-700" 
              onClick={() => setShowPendingApplications(false)}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="max-h-96 overflow-y-auto">
          {pendingApplications.length > 0 ? (
            <table className="w-full">
              <thead className="bg-accent-50">
                <tr>
                  <th className="p-2 text-left">Client Name</th>
                  <th className="p-2 text-left">Platform</th>
                  <th className="p-2 text-left">Status</th>
                  <th className="p-2 text-left">Submitted</th>
                  <th className="p-2 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {pendingApplications.map((app) => (
                  <tr key={app.id} className="border-b">
                    <td className="p-2">{app.clientName}</td>
                    <td className="p-2 capitalize">{app.platform}</td>
                    <td className="p-2">
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        app.status === 'submitted' ? 'bg-blue-100 text-blue-800' :
                        app.status === 'signed' ? 'bg-green-100 text-green-800' :
                        app.status === 'pending_signature' ? 'bg-yellow-100 text-yellow-800' :
                        app.status === 'cancelled' ? 'bg-red-100 text-red-800' :
                        'bg-gray-100 text-gray-800'
                      }`}>
                        {app.status.replace('_', ' ')}
                      </span>
                    </td>
                    <td className="p-2">{new Date(app.submittedAt).toLocaleString()}</td>
                    <td className="p-2">
                      <button className="text-primary-600 hover:text-primary-800 mr-2">Review</button>
                      <button className="text-green-600 hover:text-green-800">Approve</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-8">
              <p>No pending applications</p>
            </div>
          )}
        </div>

        <div className="mt-4 flex justify-end">
          <button 
            className="btn-outline" 
            onClick={() => setShowPendingApplications(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
